export default "__VITE_ASSET__IszOxHcM__"